export default __webpack_public_path__ + "static/media/Sample.7d8588f6.pdf";